var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { onLongTouch } from './slotUtils';
import SlotTitle from './SlotTitle';
var GenericSlot = /** @class */ (function (_super) {
    __extends(GenericSlot, _super);
    function GenericSlot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            sectionToggled: _this.props.expanded || _this.props.slot.toggled,
            favorite: false
        };
        _this.onClick = function () {
            _this.setState({
                sectionToggled: !_this.state.sectionToggled
            });
        };
        _this.onLongTouchClick = function () {
            onLongTouch(_this.props.slot, _this.props.match);
        };
        return _this;
    }
    GenericSlot.prototype.renderSlotTitle = function () {
        var _a = this.props, slot = _a.slot, outcomes = _a.outcomes, gridLocalization = _a.gridLocalization, match = _a.match;
        var slotNameProps = {
            slot: slot,
            outcome: outcomes.toArray()[0],
            gridLocalization: gridLocalization,
            match: match,
            click: this.onClick,
            longTouch: this.onLongTouchClick
        };
        return _jsx(SlotTitle, __assign({}, slotNameProps));
    };
    return GenericSlot;
}(React.Component));
GenericSlot.propTypes = {
    outcomes: PropTypes.object.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    slot: PropTypes.object.isRequired,
    slotName: PropTypes.string,
    match: PropTypes.object.isRequired,
    section: PropTypes.string.isRequired,
    expanded: PropTypes.bool.isRequired
};
export default GenericSlot;



// WEBPACK FOOTER //
// ./src/components/grid/event/slots/GenericSlot.jsx